import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row } from "antd";
import * as actions from "./../../actions";

// const  = ({ onLoginWithToken, ...rest }) => {
class DealerPortalAccess extends Component {
  componentDidMount() {
    const { token } = this.props.match.params;
    console.log("token.. ", token);
    if (token) {
      const { onLoginWithToken } = this.props;
      onLoginWithToken(token);
    }
  }
  render() {
    return (
      <Row
        className="padding-for-nav"
        type="flex"
        align="middle"
        justify="center"
      >
        <h3>Dealer portal access, please wait...</h3>
      </Row>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onLoginWithToken: bindActionCreators(actions.loginWithToken, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(DealerPortalAccess);

DealerPortalAccess.propTypes = {
  onLoginWithToken: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/dealerportalaccess/index.js